<template>
  <form @submit.prevent="addAddress()">
    <div class="mb-3">
      <label>Tarix *</label>
      <div class="input-group">
        <select class="form-control" v-model="selectedDay" required>
          <option v-for="d in 31" :key="d" :value="d">{{ d }}</option>
        </select>
        <select class="form-control" v-model="selectedMonth" required>
          <option :value="1">Yanvar</option>
          <option :value="2">Fevral</option>
          <option :value="3">Mart</option>
          <option :value="4">Aprel</option>
          <option :value="5">May</option>
          <option :value="6">İyun</option>
          <option :value="7">İyul</option>
          <option :value="8">Avqust</option>
          <option :value="9">Sentyabr</option>
          <option :value="10">Oktyabr</option>
          <option :value="11">Noyabr</option>
          <option :value="12">Dekabr</option>
        </select>
      </div>
    </div>
    <div class="mb-3">
      <label>Başlıq *</label>
      <input class="form-control" v-model="name" required>
    </div>
    <div class="mb-3">
      <label>Əlavə qeyd *</label>
      <textarea class="form-control" v-model="description"></textarea>
    </div>
    <div class="mb-3">
      <button class="btn btn-success btn-lg">
        Yadda saxla
      </button>
      <button type="button" class="btn btn-outline-dark ml-3 btn-lg" @click.prevent="$emit('modalClose')">
        Ləğv et
      </button>
    </div>
  </form>
</template>

<script>
import {mapState} from 'vuex';
import {updateSpecialDay} from "@/repositories/UserRepository";

export default {
  props: {
    specialDay: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      id: 0,
      selectedDay: 1,
      selectedMonth: 1,
      name: '',
      description: '',
    };
  },
  computed: {
    ...mapState({
      loading: state => state.app.loading,
      user: state => state.auth.user,
      token: state => state.auth.token,
    }),
  },
  methods: {
    addAddress() {


      updateSpecialDay(this.token, this.id, this.name, this.description, this.selectedMonth, this.selectedDay).then(data => {
        if (data.code === 200) {
          this.$emit('dayUpdated')

          this.name = '';
          this.description = '';
          this.selectedMonth = 0;
          this.selectedDay = 0;

        } else {
          alert("Error " + data.code + "; " + data.message);
        }
      });

    },
  },
  emits: ['addressCreated'],
  created() {

    if (this.specialDay) {
      this.id = this.specialDay.id;
      this.selectedDay = parseInt(this.specialDay.day);
      this.selectedMonth =  parseInt(this.specialDay.month);
      this.name = this.specialDay.name;
      this.description = this.specialDay.description;
    }

  }
}
</script>
